import {
    LEARN_TASKS,
    type LearnTask,
} from '@apps/web/features/learn_phoebe/model/learn_content';

// The sidebar "Learn Phoebe" checklist: the tasks a scheduler tries once.
//
// A step is an id plus a pointer to the task it demos — it does NOT restate the
// task's title, tip, or prompt. Those live in one place (LEARN_TASKS), so the
// dialog and the page can never show different words for the same task, and the
// prompt the demo plays is the prompt the button seeds.
//
// Step ids must match AGENT_CHECKLIST_STEP_IDS on the API — dropping a step
// here means dropping it there too.
export type ChecklistStep = {
    readonly id: string;
    readonly taskId: LearnTask['id'];
};

export const GET_STARTED_STEPS: ReadonlyArray<ChecklistStep> = [
    { id: 'mention_records', taskId: 'mention' },
    { id: 'one_off_sms', taskId: 'text' },
    { id: 'download_report', taskId: 'report' },
    { id: 'watch_follow_up', taskId: 'watch' },
    { id: 'guided_walkthrough', taskId: 'walkthrough' },
];

const TASK_BY_ID: ReadonlyMap<LearnTask['id'], LearnTask> = new Map(
    LEARN_TASKS.map((task) => [task.id, task]),
);

export function checklistStepTask(step: ChecklistStep): LearnTask {
    // taskId is typed as LearnTask['id'], so every step resolves.
    return TASK_BY_ID.get(step.taskId)!;
}
